import React from "react";
import "./footer.scss";
import { WMLogoSmall } from "wm_global";

export const AppFooter = () => {
  return (
    <footer className="text-center py-4 pwm-dark-blue-bkg pwm-white-text theresa-footer">
      <div>
        © {new Date().getFullYear()} PrintWithMe Inc. All Rights Reserved.
      </div>
      <br />
      <ul className="list-unstyled d-flex justify-content-center">
        <li className="mx-1 cursor-pointer">
          <a href="https://www.printwithme.com/terms/">Terms</a>
        </li>
        <li className="mx-1 cursor-pointer">
          <a href="https://www.printwithme.com/privacy-policy/">Privacy</a>
        </li>
      </ul>
      <div className="d-flex justify-content-center mt-4">
        <WMLogoSmall />
      </div>
    </footer>
  );
};
